import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useContext } from "react";

const SideMenu = (props) => {
  
    let navigate = useNavigate();
    const[activeTab,setActiveTab]=useState('')

    function Dashboard(){
        setActiveTab('dashboard')
        navigate('/dashboard')
    }
    
    function Customers(){
        setActiveTab('customers')
        navigate('/customers')
    }

    function DeletedCustomers(){
        setActiveTab('deleted_customers')
        navigate('/deleted_customers')
    }

    function Providers(){
        setActiveTab('providers')
        navigate('/providers')
    }

    function DeletedProviders(){
        setActiveTab('deleted_providers')
        navigate('/deleted_providers')
    }

    function Requests(){
        setActiveTab('requests')
        navigate('/requests')
    }

    function Bookings(){
        setActiveTab('bookings')
        navigate('/bookings')
    }

    function ProviderPayments(){
        setActiveTab('provider_payments')
        navigate('/provider_payments')
    }

    function WeeklyCharges(){
        setActiveTab('weekly_charges')
        navigate('/weekly_charges')
    }

    return (
    <div class="left_sidebar">
        <ul>
            <li className={activeTab == 'dashboard' ? 'active' : ''}><a onClick={Dashboard}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Dashboard</span></a></li>
            <li className={activeTab == 'customers' ? 'active' : ''}><a onClick={Customers}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Customers</span></a></li>
            <li className={activeTab == 'deleted_customers' ? 'active' : ''}><a onClick={DeletedCustomers}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Deleted Customers</span></a></li>
            <li className={activeTab == 'providers' ? 'active' : ''}><a onClick={Providers}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Providers</span></a></li>
            <li className={activeTab == 'deleted_providers' ? 'active' : ''}><a onClick={DeletedProviders}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Deleted Providers</span></a></li>
            <li className={activeTab == 'requests' ? 'active' : ''}><a onClick={Requests}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Requests</span></a></li>
            <li className={activeTab == 'bookings' ? 'active' : ''}><a onClick={Bookings}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Bookings</span></a></li>
            <li className={activeTab == 'provider_payments' ? 'active' : ''}><a onClick={ProviderPayments}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Provider Payments</span></a></li>
            <li className={activeTab == 'weekly_charges' ? 'active' : ''}><a onClick={WeeklyCharges}><i class="fa fa-tachometer" aria-hidden="true"></i><span>Weekly Charges</span></a></li>
            
            {/* <li><a href="trip_notification.html"><i class="fa fa-bell-o" aria-hidden="true"></i><span>Trip Notifications</span></a></li>
            <li><a href="accepted_payment.html"><i class="fa fa-credit-card" aria-hidden="true"></i><span>Accepted Payments</span></a></li>
            <li><a href="bank_account.html"><i class="fa fa-university" aria-hidden="true"></i><span>Bank Accounts</span></a></li>
            <li><a href="commission.html"><i class="fa fa-ticket" aria-hidden="true"></i><span>Commission</span></a></li>
            <li><a href="payment_transaction.html"><i class="fa fa-money" aria-hidden="true"></i><span>Payment Transactions</span></a></li>
            <li><a href="subscription_plans.html"><i class="fa fa-envelope-open-o" aria-hidden="true"></i><span>Subscription Plans</span></a></li> */}
        </ul>
    </div>
    );
};
export default SideMenu;
